import { Category } from 'mdello-client-ts/dist/src/interfaces/providers/ecommerce/category.interface';

interface ExtendedCategory extends Category {
  children?: ExtendedCategory[];
}

export const getAllCategories = (categories: ExtendedCategory[], index = 0): ExtendedCategory[] => {
  if (!Array.isArray(categories)) return [];
  const allCategories = categories.flatMap((category: ExtendedCategory) => {
    if (!category) return [];
    if (!category.children) {
      return [{ ...category, index }];
    }
    if (category.children?.length) {
      return [{ ...category, index }, ...getAllCategories(category.children, index + 1)];
    }
    return [{ ...category, index }];
  });

  return allCategories;
};
